import { gql } from "generated-graphql";

export const SUGGESTED_TASKS_QUERY = gql(`
  query SuggestedTasks($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    suggestedTasks(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      count
      items {
        id
        title
        description
        startDate
        frequency
        interval
        facilities {
          id
          name
        }
        documents {
          id
          title
          documentType
          fileExtension
          sizeMegabytes
        }
        createdAt
      }
    }
  }
`);

export const SUGGESTED_TASKS_COUNT_QUERY = gql(`
  query SuggestedTasksCount($search: String) {
    suggestedTasks(search: $search, page: 0, pageSize: 0) {
      count
    }
  }
`);
